export const BANK_NAMES = [
  { name: 'Andhra Pradesh Grameena Vikas Bank', id: 1 },
  { name: 'Andhra Pragathi Grameena Bank', id: 2 },
  { name: 'Arunachal Pradesh Rural Bank', id: 3 },
  { name: 'Aryavart Bank', id: 4 },
  { name: 'Assam Gramin Vikash Bank', id: 5 },
  { name: 'AU Small Finance Bank', id: 6 },
  { name: 'Axis Bank', id: 7 },
  { name: 'Bandhan Bank limited', id: 8 },
  { name: 'Bangiya Gramin Vikash Bank', id: 9 },
  { name: 'Bank of America', id: 10 },
  { name: 'Bank of Bahrain and Kuwait B.S.C', id: 11 },
  { name: 'Bank of Baroda', id: 12 },
  { name: 'Bank of India', id: 13 },
  { name: 'Bank of Maharashtra', id: 14 },
  { name: 'Barclays Bank', id: 15 },
  { name: 'Baroda Gujarat Gramin Bank', id: 16 },
  { name: 'Baroda Rajasthan Kshetriya Gramin Bank', id: 17 },
  { name: 'Baroda UP Bank', id: 18 },
  { name: 'BNP Paribas', id: 19 },
  { name: 'Canara Bank', id: 20 },
  { name: 'Capital Small Finance Bank', id: 21 },
  { name: 'Catholic Syrian Bank', id: 22 },
  { name: 'Central Bank of India', id: 23 },
  { name: 'Chaitanya Godavari Gramin Bank', id: 24 },
  { name: 'Chhattisgarh Rajya Gramin Bank', id: 25 },
  { name: 'Citi Bank', id: 26 },
  { name: 'City Union Bank', id: 27 },
  { name: 'Dakshin Bihar Gramin Bank', id: 28 },
  { name: 'DCB Bank Ltd.', id: 29 },
  { name: 'Development Bank of Singapore', id: 30 },
  { name: 'Dhanalakshmi Bank', id: 31 },
  { name: 'Ellaquai Dehati Bank', id: 32 },
  { name: 'Emirates NBD Bank (P J S C)', id: 33 },
  { name: 'Equitas Small Finance Bank', id: 34 },
  { name: 'ESAF Small Finance Bank', id: 35 },
  { name: 'Federal Bank', id: 36 },
  { name: 'Fincare Small Finance Bank', id: 37 },
  { name: 'HDFC Bank', id: 38 },
  { name: 'Himachal Pradesh Gramin Bank', id: 39 },
  { name: 'HSBC Bank', id: 40 },
  { name: 'ICICI Bank', id: 41 },
  { name: 'IDBI Bank', id: 42 },
  { name: 'IDFC bank', id: 43 },
  { name: 'Indian Bank', id: 44 },
  { name: 'Indian Overseas Bank', id: 45 },
  { name: 'Indusind Bank', id: 46 },
  { name: 'Jammu And Kashmir Bank', id: 47 },
  { name: 'Jammu And Kashmir Grameen Bank', id: 48 },
  { name: 'Jana Small Finance Bank', id: 49 },
  { name: 'Jharkhand Rajya Gramin Bank', id: 50 },
  { name: 'Karnataka Bank', id: 51 },
  { name: 'Karnataka Gramin Bank', id: 52 },
  { name: 'Karnataka Vikas Grameena Bank', id: 53 },
  { name: 'Karur Vysya Bank', id: 54 },
  { name: 'Kerala Gramin Bank', id: 55 },
  { name: 'Kotak Mahindra Bank', id: 56 },
  { name: 'Lakshmi Vilas Bank', id: 57 },
  { name: 'Madhya Pradesh Gramin Bank', id: 58 },
  { name: 'Madhyanchal Gramin Bank', id: 59 },
  { name: 'Maharashtra Gramin Bank', id: 60 },
  { name: 'Manipur Rural Bank', id: 61 },
  { name: 'Meghalaya Rural Bank', id: 62 },
  { name: 'Mizoram Rural Bank', id: 63 },
  { name: 'Nagaland Rural Bank', id: 64 },
  { name: 'North East Small Finance Bank', id: 65 },
  { name: 'Odisha Gramya Bank', id: 66 },
  { name: 'Paschim Banga Gramin Bank', id: 67 },
  { name: 'Prathama UP Gramin Bank', id: 68 },
  { name: 'Puduvai Bharathiar Grama Bank', id: 69 },
  { name: 'Punjab and Sind Bank', id: 70 },
  { name: 'Punjab Gramin Bank', id: 71 },
  { name: 'Punjab National Bank', id: 72 },
  { name: 'Rajasthan Marudhara Gramin Bank', id: 73 },
  { name: 'Ratnakar Bank', id: 74 },
  { name: 'Saptagiri Gramin Bank', id: 75 },
  { name: 'Sarva Haryana Gramin Bank', id: 76 },
  { name: 'Saurashtra Gramin Bank', id: 77 },
  { name: 'SBM BANK (INDIA) LIMITED', id: 78 },
  { name: 'Shinhan Bank', id: 79 },
  { name: 'South Indian Bank', id: 80 },
  { name: 'Standard Chartered Bank', id: 81 },
  { name: 'State Bank of India', id: 82 },
  { name: 'Suryoday Small Finance Bank', id: 83 },
  { name: 'Tamil Nadu Grama Bank', id: 84 },
  { name: 'Tamilnaad Mercantile Bank', id: 85 },
  { name: 'Telangana Grameena Bank', id: 86 },
  { name: 'Tripura Gramin Bank', id: 87 },
  { name: 'UCO Bank', id: 88 },
  { name: 'Ujjivan Small Finance Bank', id: 89 },
  { name: 'Union Bank Of India', id: 90 },
  { name: 'Utkal Grameen Bank', id: 91 },
  { name: 'Utkarsh Small Finance Bank', id: 92 },
  { name: 'Uttar Bihar Gramin Bank', id: 93 },
  { name: 'Uttarakhand Gramin Bank', id: 94 },
  { name: 'Uttarbanga Kshetriya Gramin Bank', id: 95 },
  { name: 'Vidarbha Konkan Gramin Bank', id: 96 },
  { name: 'Yes Bank Ltd', id: 97 },
];
